module.exports = {
    base_url: "https://read-indonesia-api.komunestudio.com/"
    // base_url: 'https://staging-api.readindonesia.id/',
    // base_url: "https://barcode-api.komunestudio.com/"
    
};
